import PropTypes from 'prop-types'
import React from 'react'
import { VStack } from '@chakra-ui/react'
import Resume from './sections/Resume'
import CompanyInfo from './sections/CompanyInfo'

export default function NormalInfo({ showMore, data = {} }) {
  return (
    <VStack alignItems="flex-start" spacing="32px">
      <Resume
        nCargaPromedio={data?.nCargaPromedio}
        nPagosPendientes={data?.nPagosPendientes}
      />
      <CompanyInfo showMore={showMore} data={data} />
    </VStack>
  )
}

NormalInfo.propTypes = {
  data: PropTypes.shape({
    nCargaPromedio: PropTypes.number,
    nPagosPendientes: PropTypes.number,
  }),
  showMore: PropTypes.bool,
}
